<template>
	<v-card class="flat-border-card form" :class="{ edit: isEditInternal, 'has-error': hasError }" flat>
		<v-card-title>
			<h3 class="headline mb-0">{{ title }}</h3>
			<v-spacer></v-spacer>
			<div v-if="canEdit">
				<v-btn v-if="!isEditInternal" icon @click="toggleEdit(true)"><v-icon>edit</v-icon></v-btn>
				<div v-else>
					<v-btn @click="onCancelClick" flat>Cancel</v-btn>
					<v-btn @click="submit" class="primary" flat :loading="isSaving">{{ submitBtnText }}</v-btn>
				</div>
			</div>
		</v-card-title>
		<v-card-text>
			<component ref="form" :is="currentForm" :isEdit="isEditInternal" v-model="formInternal" :employeeId="employeeId"></component>
		</v-card-text>
	</v-card>
</template>

<script>
	import EmergencyContactForm from '@/components/employee/forms/EmergencyContactForm';
	import BasicInfoForm from '@/components/employee/forms/BasicInfoForm';
	import PersonalDetailsForm from '@/components/employee/forms/PersonalDetailsForm';
	import WorkDetailsForm from '@/components/employee/forms/WorkDetailsForm';
	import HrPoliciesForm from '@/components/employee/forms/HrPoliciesForm';
	import TagsForm from '@/components/employee/forms/TagsForm';
	import OtherDetailsForm from '@/components/employee/forms/OtherDetailsForm';

	export default {
		components: {
			EmergencyContactForm,
			BasicInfoForm,
			PersonalDetailsForm,
			WorkDetailsForm,
			HrPoliciesForm,
			TagsForm,
			OtherDetailsForm
		},
		props: {
			form: {
				type: String,
				required: true
			},
			value: {
				type: [Object, Array],
				required: true
			},
			title: {
				type: String,
				required: true
			},
			submitBtnText: {
				type: String,
				default: 'Done'
			},
			isSaving: {
				type: Boolean,
				default: false
			},
			employeeId: {
				type: String,
				required: false
			},
			canEdit: {
				type: Boolean,
				default: false
			},
			defaultState: {
				type: String,
				default: 'view'
			}
		},
		data() {
			return {
				isEditInternal: this.isEdit,
				validateChildForm: null,
				originalDataSerialised: null,
				formInternal: null,
				hasError: false
			};
		},
		computed: {
			currentForm() {
				return this.form;
			},
			formInternalSerialised() {
				return JSON.stringify(this.formInternal);
			}
		},
		watch: {
			value: {
				immediate: true,
				handler(newVal) {
					this.originalDataSerialised = JSON.stringify(newVal);
					this.formInternal = JSON.parse(JSON.stringify(newVal));
				}
			},
			formInternalSerialised() {
				this.emitErrorStateChanged();
			}
		},
		created() {
			if (this.canEdit && this.defaultState === 'edit') {
				this.toggleEdit(true);
			}
		},
		methods: {
			toggleEdit(isEdit) {
				this.isEditInternal = isEdit;
			},
			validate() {
				return this.$refs.form.$_validateForm();
			},
			submit() {
				const validationResult = this.validate();
				this.emitErrorStateChanged();
				if (validationResult) {
					this.$emit('input', this.formInternal);
				}
				return validationResult;
			},
			onCancelClick() {
				this.formInternal = JSON.parse(this.originalDataSerialised);
				this.$nextTick(() => {
					this.emitErrorStateChanged();
				});

				this.toggleEdit(false);
			},
			emitErrorStateChanged() {
				if (this.$refs.form && this.$refs.form.$v) {
					this.hasError = this.$refs.form.$v.$error;
					this.$emit('errorStateChanged', this.hasError);
				}
			}
		}
	};
</script>
